import React, { useState, useEffect } from 'react';
import '../../entrydoor.css';
import { formatToDecimal } from '../conversions';
import { formatToFractional } from '../conversions';

const SideLiteSize = ({ value, onChange, label = 'Side Lite Size:', disabled = false }) => {
    const [selectedSideLiteSize, setSelectedSideLiteSize] = useState(value || "0\"");
     const [SideLiteSizeError, setSideLiteSizeError] = useState("");

     useEffect(() => {
        //valuealert(value);
        //value = 0;
        //setSelectedSideLiteSize(value);
    }, [value]);

     const handleSideLiteSizeChange = (e) => {
        //setSelectedSideLiteSize(e.target.value);
        validateSideLiteSize(e.target.value);
        onChange(e.target.value);
    };
    const validateSideLiteSize = (value) => {
        const numericValue = value; //value.replace(/\D/g, ""); // Allow only numbers
        setSelectedSideLiteSize(numericValue);
      
        if (numericValue && (numericValue < 0 || numericValue > 20)) {
            setSideLiteSizeError('Side Lite Size must be betweenn 0" and 20"');
        } else {
            setSideLiteSizeError("");
        }
    };

    const handleFocus = (e) => {
      const decimalValue = formatToDecimal(e.target.value);
      setSelectedSideLiteSize(decimalValue);
    };

    const handleBlur = (e) => {
      const fractionalValue = formatToFractional(e.target.value);
      setSelectedSideLiteSize(fractionalValue);
      onChange(fractionalValue);
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="SideLiteSize">{label}</label>
            <input
                disabled={disabled}
                id="SideLiteSize"
                value={selectedSideLiteSize}
                onChange={handleSideLiteSizeChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
            >
            </input>
            {SideLiteSizeError && <p className="error">{SideLiteSizeError}</p>}
        </div>
    );
};

export default SideLiteSize;
